import { Form, Slider } from "antd";

const Gcs = ({ initial = false, handleChange, values }) => {
  return (
    <div className="gcs-left-container">
      <div className="gcs-scale-card">
        <Form.Item
          label="Eye Opening Response (E)"
          name={
            initial ? ["gcs", "eye_opening_response"] : "eye_opening_response"
          }
        >
          <Slider
            marks={{
              0: "NT",
              1: "1",
              2: "2",
              3: "3",
              4: "4",
            }}
            step={1}
            max={4}
            min={0}
            onChange={(value) => handleChange("eye_opening_response", value)}
            value={values?.eye_opening_response || 0}
            className="gcs-slider"
            tooltip={{ open: false }}
          />
        </Form.Item>
      </div>

      <div className="gcs-scale-card">
        <Form.Item
          label="Verbal Response (V)"
          name={initial ? ["gcs", "verbal_response"] : "verbal_response"}
        >
          <Slider
            marks={{
              0: "NT",
              1: "1",
              2: "2",
              3: "3",
              4: "4",
              5: "5",
            }}
            step={1}
            max={5}
            min={0}
            onChange={(value) => handleChange("verbal_response", value)}
            value={values?.verbal_response || 0}
            className="gcs-slider"
            tooltip={{ open: false }}
          />
        </Form.Item>
      </div>

      <div className="gcs-scale-card">
        <Form.Item
          label="Motor Response (M)"
          name={initial ? ["gcs", "motor_response"] : "motor_response"}
        >
          <Slider
            marks={{
              0: "NT",
              1: "1",
              2: "2",
              3: "3",
              4: "4",
              5: "5",
              6: "6",
            }}
            step={1}
            max={6}
            min={0}
            onChange={(value) => handleChange("motor_response", value)}
            value={values?.motor_response || 0}
            className="gcs-slider"
            tooltip={{ open: false }}
          />
        </Form.Item>
      </div>
    </div>
  );
};

export default Gcs;
